import { Flame, Rocket, Ghost, Zap, Gem, Crown, Skull, Bot } from "lucide-react";

export const AVATAR_ICONS = { Flame, Rocket, Ghost, Zap, Gem, Crown, Skull, Bot };

// Mirrors backend battlepass.COSMETICS so avatars render app-wide without an API call.
export const CATALOG = {
  av_flame:  { type: "avatar", name: "Ember", rarity: "common", icon: "Flame", grad: "from-orange-500 to-red-600" },
  av_rocket: { type: "avatar", name: "Voyager", rarity: "common", icon: "Rocket", grad: "from-sky-500 to-indigo-600" },
  av_ghost:  { type: "avatar", name: "Phantom", rarity: "rare", icon: "Ghost", grad: "from-slate-400 to-slate-700" },
  av_zap:    { type: "avatar", name: "Voltage", rarity: "rare", icon: "Zap", grad: "from-yellow-400 to-amber-600" },
  av_gem:    { type: "avatar", name: "Prism", rarity: "epic", icon: "Gem", grad: "from-cyan-400 to-blue-600" },
  av_crown:  { type: "avatar", name: "Monarch", rarity: "epic", icon: "Crown", grad: "from-amber-400 to-yellow-600" },
  av_skull:  { type: "avatar", name: "Reaper", rarity: "legendary", icon: "Skull", grad: "from-fuchsia-500 to-purple-700" },
  av_bot:    { type: "avatar", name: "Overclock", rarity: "legendary", icon: "Bot", grad: "from-emerald-400 to-cyan-600" },
  fr_bronze: { type: "frame", name: "Bronze Ring", rarity: "common", ring: "ring-2 ring-orange-700/70" },
  fr_silver: { type: "frame", name: "Silver Ring", rarity: "rare", ring: "ring-2 ring-slate-300/80" },
  fr_gold:   { type: "frame", name: "Gold Aura", rarity: "epic", ring: "ring-4 ring-amber-400/80" },
  fr_neon:   { type: "frame", name: "Neon Pulse", rarity: "legendary", ring: "ring-4 ring-fuchsia-500/80" },
};

export const RARITY_COLORS = {
  common: "text-gray-300 border-gray-500/40",
  rare: "text-sky-300 border-sky-500/40",
  epic: "text-fuchsia-300 border-fuchsia-500/40",
  legendary: "text-amber-300 border-amber-500/50",
};

// Render an avatar with an optional frame. `catalog` defaults to the embedded CATALOG.
export function Avatar({ avatarId, frameId, catalog = CATALOG, size = 40, fallbackChar = "?" }) {
  const av = avatarId && catalog?.[avatarId];
  const fr = frameId && catalog?.[frameId];
  const Icon = av ? AVATAR_ICONS[av.icon] : null;
  const ring = fr?.ring || "ring-1 ring-white/10";
  return (
    <div
      className={`rounded-full flex items-center justify-center ${ring} bg-gradient-to-br ${av ? av.grad : "from-slate-600 to-slate-800"}`}
      style={{ width: size, height: size }}
    >
      {Icon ? <Icon className="text-white" style={{ width: size * 0.5, height: size * 0.5 }} />
        : <span className="text-white font-bold" style={{ fontSize: size * 0.4 }}>{fallbackChar}</span>}
    </div>
  );
}
